import { render } from "./betaApp.vue?vue&type=template&id=142dcea9"
import script from "./betaApp.vue?vue&type=script&lang=js"
export * from "./betaApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__